import { NeoModel } from "@singularsystems/neo-core";
import { TradeOrderStatus } from "../Enums/TradeOrderStatus";

/**
 * Batch release trade orders command.
 */
@NeoModel
export default class ReleaseTradeOrdersCommand {
    /**
     * List of trade order IDs to release.
     */
    public tradeOrderIds: number[] = [];

    /**
     * Target status for the trade orders (should be Released).
     */
    public targetStatus: TradeOrderStatus = TradeOrderStatus.Released;
}
